import { isoCountries } from "../../../../utils/constants";

export default function ProfileDetails({ userDetails }) {
  return (
    <div>
      <h4 className="tw-mx-4 tw-my-3 tw-text-xl tw-font-semibold">Profile Details</h4>

      <div className="tw-mx-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-border">
        <div className="tw-p-4">
          <div className="tw-w-full">
            <div className="tw-flex tw-flex-wrap">
              <div className="tw-w-1/3">
                <h2 className="tw-text-xl tw-font-bold tw-my-1">{userDetails.fullName}</h2>
                <h5 className="tw-text-gray-700">{userDetails.email}</h5>
              </div>
              <div className="tw-w-1/3"></div>
              <div className="tw-w-1/3"></div>
            </div>

            <div className="tw-flex tw-flex-wrap tw-mt-4">
              <div className="tw-w-1/3 tw-mb-3">
                <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">Full Name</label>
                <label className="tw-block tw-text-gray-900 tw-capitalize tw-font-semibold">{userDetails.fullName}</label>
              </div>

              <div className="tw-w-1/3 tw-mb-3">
                <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">Phone Number</label>
                <label className="tw-block tw-text-gray-900 tw-font-semibold">{userDetails.phoneNumber || "-"}</label>
              </div>

              <div className="tw-w-1/3 tw-mb-3">
                <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">Country</label>
                <label className="tw-block tw-text-gray-900 tw-capitalize tw-font-semibold">{isoCountries[userDetails.country] || userDetails.country || ""}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
